import { render, staticRenderFns } from "./RecurringEventsButton.vue?vue&type=template&id=17f5f8d2&scoped=true"
import script from "./RecurringEventsButton.vue?vue&type=script&lang=js"
export * from "./RecurringEventsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f5f8d2",
  null
  
)

export default component.exports